import {type ActionTree} from 'vuex';
import localStorage from '../../../../library/localStorage';

const actions: ActionTree<ModulePageState, RootState> = {
    get({
        commit,
        state,
    })
    {
        if (null === state.listDisplayType)
        {
            commit('setListDisplayType',
                {
                    type: localStorage.get('pageListDisplayType', 0),
                    preventUpdate: true,
                },
            );
        }

        if (null === state.openedFoldersFileTree)
        {
            commit('setOpenedFoldersFileTree', localStorage.get('pageFileTree', []));
        }

        if (null === state.showFileTree)
        {
            commit(
                'setShowFileTree',
                {
                    show: !!localStorage.get('pageShowFileTree', 1),
                    preventUpdate: true,
                },
            );
        }
    },
};

export default actions;